import axios from 'axios';

const BASE = '';
const API = axios.create({ baseURL: `${BASE}/api` });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export const authService = {
  login: (data) => API.post('/auth/login', data),
  me: () => API.get('/auth/me'),
};

export const orderService = {
  getAll: (search) => API.get('/orders', { params: search ? { search } : {} }),
  getOne: (id) => API.get(`/orders/${id}`),
  create: (data) => API.post('/orders', data),
  update: (id, data) => API.put(`/orders/${id}`, data),
  updateStatus: (id, status) => API.patch(`/orders/${id}/status`, { status }),
  anular: (id, motivo) => API.patch(`/orders/${id}/anular`, { motivo }),
};

export const clientService = {
  getAll: (search) => API.get('/clients', { params: search ? { search } : {} }),
  getOne: (id) => API.get(`/clients/${id}`),
};

export const inventoryService = {
  getProducts: () => API.get('/inventory/products'),
  getCategories: () => API.get('/inventory/categories'),
  getAlerts: () => API.get('/inventory/alerts'),
  createProduct: (data) => API.post('/inventory/products', data),
  deleteProduct: (id) => API.delete(`/inventory/products/${id}`),
  createVariant: (data) => API.post('/inventory/variants', data),
  updateVariant: (id, data) => API.put(`/inventory/variants/${id}`, data),
  addMovement: (data) => API.post('/inventory/movements', data),
};

export const configService = {
  getLogoUrl: () => `${BASE}/api/config/logo`,
  uploadLogo: (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    return API.post('/config/logo', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export const userService = {
  getAll: () => API.get('/users'),
  create: (data) => API.post('/users', data),
  update: (id, data) => API.put(`/users/${id}`, data),
  changePassword: (id, data) => API.put(`/users/${id}/password`, data),
};

export const rutaService = {
  optimizar: (origen, destinos) => API.post('/orders/optimizar-ruta', { origen, destinos }),
};

export const entregaService = {
  disponibles: () => API.get('/entregas/disponibles'),
  choferes: () => API.get('/entregas/choferes'),
  asignar: (order_id, chofer_id) => API.post('/entregas/asignar', { order_id, chofer_id }),
  reasignar: (id, chofer_id) => API.post(`/entregas/${id}/reasignar`, { chofer_id }),
  desasignar: (id) => API.delete(`/entregas/${id}`),
  listar: () => API.get('/entregas'),
  caja: (fecha) => API.get('/entregas/caja', { params: fecha ? { fecha } : {} }),
  cajaSemana: (desde, hasta) => API.get('/entregas/caja-semana', { params: { desde, hasta } }),
  misEntregas: () => API.get('/entregas/mis-entregas'),
  entregar: (id, pagos, notas) => API.post(`/entregas/${id}/entregar`, { pagos, notas }),
  editarPagos: (id, pagos) => API.patch(`/entregas/${id}/pagos`, { pagos }),
  marcarRevisado: (id, revisado) => API.patch(`/entregas/${id}/revisar`, { revisado }),
  noEntregar: (id, motivo) => API.post(`/entregas/${id}/no-entregar`, { motivo }),
};

export const abonoService = {
  listar: (orderId) => API.get(`/abonos/orden/${orderId}`),
  crear: (order_id, monto, metodo, nota) => API.post('/abonos', { order_id, monto, metodo, nota }),
  eliminar: (id) => API.delete(`/abonos/${id}`),
};

export const tallerService = {
  pendientes: () => API.get('/taller/pendientes'),
  operarios: () => API.get('/taller/operarios'),
  asignar: (data) => API.post('/taller/asignar', data),
  quitar: (id) => API.delete(`/taller/${id}`),
  telas: () => API.get('/taller/telas'),
  marcarTela: (orderId, estado) => API.patch(`/taller/telas/${orderId}/estado`, { estado }),
  editarMetraje: (item_id, metraje) => API.patch('/taller/metraje', { item_id, metraje }),
  miTrabajo: () => API.get('/taller/mi-trabajo'),
  terminar: (id) => API.post(`/taller/mi-trabajo/${id}/terminar`),
  pagos: (params) => API.get('/taller/pagos', { params }),
  marcarPagado: (id, pagado) => API.post(`/taller/pagos/${id}/pagar`, { pagado }),
  fijarMonto: (id, monto) => API.post(`/taller/pagos/${id}/monto`, { monto }),
  tarifas: () => API.get('/taller/tarifas'),
  fotos: (id) => API.get(`/taller/mi-trabajo/${id}/fotos`),
  subirFoto: (id, file) => { const fd = new FormData(); fd.append('foto', file); return API.post(`/taller/mi-trabajo/${id}/fotos`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  borrarFoto: (id, fotoId) => API.delete(`/taller/mi-trabajo/${id}/fotos/${fotoId}`),
};

export const bodegaService = {
  materiales: () => API.get('/bodega/materiales'),
  categorias: () => API.get('/bodega/categorias'),
  crearCompra: (data) => API.post('/bodega/compras', data),
  compras: () => API.get('/bodega/compras'),
  crearMaterial: (data) => API.post('/bodega/materiales', data),
  editarMaterial: (id, data) => API.patch(`/bodega/materiales/${id}`, data),
  desactivarMaterial: (id) => API.delete(`/bodega/materiales/${id}`),
  crearCategoria: (nombre) => API.post('/bodega/categorias', { nombre }),
  ajustarStock: (id, data) => API.post(`/bodega/materiales/${id}/ajustar`, data),
};

export default API;
